export const filterConditionLtIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M16.2 14.452L6.048 10 16.2 5.548 14.64 4 3 10l11.64 6z"/></svg>`,
  name: 'filter-condition-lt',
};
